import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import { ItemContainer, Modal, Cancel, Exit } from 'features/community/styled';

interface Props {
  onOk: () => void;
  visible: boolean;
  onCancel: () => void;
  communityName: string;
}

function Leave({ onOk, visible, onCancel, communityName }: Props) {
  return (
    <Modal
      onOk={onOk}
      visible={visible}
      onCancel={onCancel}
      closeIcon={<Image src="/icon/close.svg" width="10px" height="10px" />}
      width={500}
      footer={[
        // @ts-expect-error
        <Flex align="center" justify="space-between" mt="20px">
          <Cancel width="50%" onClick={onCancel}>
            <Text family="bold" size="14px" height="19px">
              Batal
            </Text>
          </Cancel>
          <Exit width="50%" onClick={onOk}>
            <Text family="bold" color="white" size="14px" height="19px">
              Keluar
            </Text>
          </Exit>
        </Flex>,
      ]}
    >
      {/* @ts-expect-error */}
      <ItemContainer justify="center" align="center" mt="60px">
        <Image
          alt="leave"
          src="images/community/leave.svg"
          width={160}
          height={120}
        />
        <Text
          // @ts-expect-error
          mt="20px"
          size="18px"
          height="24.3px"
          family="bold"
          align="center"
          mb="12px"
        >
          Keluar dari Komunitas?
        </Text>
        <Text
          size="14px"
          height="19px"
          color="rgba(133, 133, 133, 1)"
          // @ts-expect-error
          mb="20px"
        >
          Apakah kamu yakin keluar dari komunitas&nbsp;
          <strong>{`${communityName}?`}</strong>
        </Text>
      </ItemContainer>
    </Modal>
  );
}

export default Leave;
